import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'lean-modal',
  templateUrl: './lean-modal.component.html',
  styleUrls: ['./lean-modal.component.scss']
})
export class LeanModal implements OnInit {

  constructor() { }

  @Input() width      : string;
  @Input() hideHeader = false;
  @Input() hideFooter = false;
  
  public visible = false;
  public visibleAnimate = false;
  
  ngOnInit() {
  }

  public show(): void {
    this.visible = true;
    setTimeout(() => this.visibleAnimate = true, 100);
}

public hide(): void {
    this.visibleAnimate = false;
    setTimeout(() => this.visible = false, 300);
}

public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains('modal')) {
        this.hide();
    }
}

}
